
import Button from '../../../components/base/Button';

export default function ProductsCTA() {
  return (
    <section className="py-20 bg-gradient-to-r from-red-600 to-red-700 relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20engineer%20designing%20custom%20fire%20protection%20system%20with%20technical%20drawings%20and%20fire%20safety%20equipment%20in%20Qatar%20engineering%20office%2C%20QCDD%20approved%20custom%20solutions%20with%20clean%20technical%20background&width=1200&height=400&seq=custom-solutions&orientation=landscape')`
        }}
      ></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-8">
            <i className="ri-tools-line text-3xl text-white"></i>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Looking for Custom Fire Protection Solutions?
          </h2>
          
          <p className="text-xl text-red-100 leading-relaxed mb-8 max-w-3xl mx-auto">
            Need a custom fire-protection equipment bundle or turnkey solution? Contact FlameGuardQA today — our team is ready to assist with design, supply and installation tailored to your specific requirements.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="secondary"
              size="lg"
              className="bg-white text-red-600 hover:bg-gray-100 shadow-xl"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Us Now
            </Button>
            <Button 
              variant="outline"
              size="lg"
              className="border-white text-white hover:bg-white hover:text-red-600"
            >
              <i className="ri-mail-line mr-2"></i>
              Request Custom Quote
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <h3 className="font-semibold mb-2">QCDD Approved</h3>
              <p className="text-red-100 text-sm">All products meet Qatar safety standards</p>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-team-line text-xl text-white"></i>
              </div>
              <h3 className="font-semibold mb-2">Expert Team</h3>
              <p className="text-red-100 text-sm">Certified engineers and technicians</p>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg mb-4">
                <i className="ri-time-line text-xl text-white"></i>
              </div>
              <h3 className="font-semibold mb-2">Fast Response</h3>
              <p className="text-red-100 text-sm">Quick installation and support</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}